import { render, staticRenderFns } from "./user_bar.vue?vue&type=template&id=003aef12"
import script from "./user_bar.vue?vue&type=script&lang=js"
export * from "./user_bar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports